import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { of, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiOrganizationsService, DialogModalService, FilesService, NotificationService } from 'src/app/services';
import { ApiService } from 'src/app/services/api.service';
import { ConfirmActionComponent } from '../../confirm/confirm-action/confirm-action.component';

@Component({
  selector: 'app-file-upload-process',
  templateUrl: './file-upload-process.component.html',
  styleUrls: ['./file-upload-process.component.css']
})
export class FileUploadProcessComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  selctedFiles: any[] = [];
  files: any[] = [];
  date: any;
  option = {
    multiple: false,
    component: ''
  }
  result: any;
  currentOrg: any;

  @Input() set data(value) {

    if (value != null) {

      this.currentOrg = this.apiOrganizations.currentOrganization;
      this.selctedFiles = value.files;
      this.date = value.date;
      this.option.multiple = value.option.multiple;
      this.option.component = value.option.component;
      this.preparingArrayBeforeUpload();

    }
  }

  constructor(
    private notification: NotificationService,
    private fileService: FilesService,
    public activeModal: NgbActiveModal,
    private api: ApiService,
    private apiOrganizations: ApiOrganizationsService,
    private dialogModal: DialogModalService
  ) { }

  ngOnInit(): void {

    this.currentOrg = this.apiOrganizations.currentOrganization;

    this.subscriptions.add(
      this.apiOrganizations.listenerCurrentOrganization().subscribe(val => {

        this.currentOrg = val;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param fileName string
   * @returns string
   */
  checkIconExt(fileName: string): string {

    return this.fileService.checkIconExt(fileName);
  }


  /**
   * 
   * @param size number
   * @returns string
   */
  convertationToMb(size: number): string {

    return this.fileService.convertationToMb(size);
  }


  /**
   * 
   * @param size number
   * @param progress number
   * @returns string
   */
  calculationOfLoadedVolume(size: number, progress: number): string {

    return this.fileService.calculationOfLoadedVolume(size, progress);
  }


  /**
   * 
   * @param files any
   */
  additionallySelectedFiles(files): void {

    for (let file of files) {

      this.files.push({
        data: file,
        inProgress: true,
        progress: 0,
        error: false,
        uploaded: false
      });
    }

    this.uploadFiles();
  }


  /**
   * 
   */
  private preparingArrayBeforeUpload(): void {

    for (let file of this.selctedFiles) {

      this.files.push({
        data: file,
        inProgress: true,
        progress: 0,
        error: false,
        uploaded: false
      });
    }

    this.uploadFiles();
  }

  /**
   * 
   */
  private uploadFiles(): void {

    this.files.forEach(file => {
      
      if (!file.uploaded) {

        if (file.data.name.length > 50) {

          this.dialogModal.open('Длина имени файла превышает 50 символов и при загрузке будет обрезана! Продолжить загрузку?', ConfirmActionComponent).then(

            (result) => {

              if (result) {

                this.uploadFile(file, this.getModifyName(file.data.name));

              }
            },
            () => { console.log('Rejected!'); }
          );

        } else {

          this.uploadFile(file);
        }

      }
    });
  }


  /**
   * 
   * @param fileName 
   * @returns 
   */
  getModifyName(fileName: string): string {

    return String(fileName.substring(0, 50) + "." + String(this.fileService.checkIconExt(fileName)));

  }


  /**
   * 
   * @param file 
   */
  uploadFile(file, modifyName: string = ''): void {

    const formData = new FormData();
    let methodName: string;

    console.log("FILE DATA: ", file.data);
    console.log("DATE: ", this.date);


    modifyName != '' ? formData.append('file', file.data, modifyName) : formData.append('file', file.data);
    formData.append('org_id', this.currentOrg.id);

    if (this.date != null) {

      formData.append('valid_to', this.date);
    }

    console.log(formData.get('file'), formData.get('org_id'), formData.get('valid_to'));

    file.inProgress = true;

    if (this.option.component == 'products') {

      if (file.data.id) {

        methodName = 'updateFile';
        formData.append('id', file.data.id);

      } else {

        methodName = 'createFile';
      }

    } else if (this.option.component == 'kaspi') {

      methodName = 'uploadPriceListFile';
      formData.append('id', file.data.id);

    } else if (this.option.component == 'organization' || this.option.component == 'user') {

      methodName = 'createFile';

    } else if (this.option.component == 'specifications' || this.option.component == "import") {

      methodName = 'readFile';

    }
    else {

      methodName = 'uploadFile';
    }

    this.fileService.upload(methodName, formData).pipe(
      map(event => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            file.progress = Math.round(event.loaded * 100 / event.total);
            break;
          case HttpEventType.Response:
            return event;
        }
      }),
      catchError((error: HttpErrorResponse) => {

        file.inProgress = false;
        file.error = true;

        this.notification.show('danger', 'Загрузка файла ' + modifyName != '' ? modifyName : file.data.name + ' не удалась.');

        console.log('[UPLOAD FILE]: ', error);

        return of('Загрузка файла ' + modifyName != '' ? modifyName : file.data.name + ' не удалась.');

      })).subscribe((event: any) => {

        if (typeof (event) === 'object') {

          console.log('[UPLOAD FILE]: ', event.body);
          file.inProgress = false;
          file.uploaded = true;

          this.result = event.body;

        }
      }
      );
  }
}
